import { LANDING_DETAIL_TYPOGRAPHY, LANDING_TYPOGRAPHY } from "../constants/landing.constants";

interface BenefitListProps {
  benefits: { title: string; description: string }[];
}

export default function BenefitList({ benefits }: BenefitListProps) {
  return (
    <section>
      <h2 className={`mb-5 ${LANDING_TYPOGRAPHY.subsectionTitle}`}>
        What You Will Get
      </h2>
      <div className="flex flex-col gap-4">
        {benefits.map((item, index) => (
          <div
            key={`${index}-${item.title}`}
            className={LANDING_DETAIL_TYPOGRAPHY.benefitCard}
          >
            <span className={LANDING_DETAIL_TYPOGRAPHY.benefitNumber}>
              {index + 1}
            </span>
            <div className="min-w-0">
              <h3 className={LANDING_DETAIL_TYPOGRAPHY.benefitTitle}>
                {item.title}
              </h3>
              <p className={LANDING_DETAIL_TYPOGRAPHY.benefitBody}>
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
